import { composeIO } from 'react-compose-io'
import { fieldsConcatenarTransformacaoApiIO } from './FieldsConcatenarTransformacaoApi.IO'
import { FieldsConcatenarTransformacaoApiView } from './FieldsConcatenarTransformacaoApi.View'

export const FieldsConcatenarTransformacaoApi = composeIO(FieldsConcatenarTransformacaoApiView, fieldsConcatenarTransformacaoApiIO)
